import { getNonQBRetailerCanonical, onCustomTarget } from '.';
export const getArticleLink = (article, linkToFm, customTarget) => {
  const retailerCanonical = getNonQBRetailerCanonical(article);
  const href = linkToFm && retailerCanonical ? retailerCanonical : article.url;
  const anchorTarget = onCustomTarget(customTarget === null || customTarget === void 0 ? void 0 : customTarget.openAllResultUrlsInSameWindow, customTarget === null || customTarget === void 0 ? void 0 : customTarget.resultUrlsToOpenInSameWindow, href, linkToFm, retailerCanonical, article.anchor_target);
  return {
    href,
    anchorTarget
  };
};